import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {environment} from '../../../environments/environment';
import {
  endImpersonateUserAction,
  impersonateUserAction,
  logoutEndImpersonateUserAction,
  switchUserAction,
} from '../store/auth/auth.actions';
import {isLoadingUserDataSelector} from '../store/auth/auth.selectors';
import {AuthService} from './auth.service';
import {Observable, take} from "rxjs";
import {SupervisorService} from "./supervisor.service";
import {Router} from "@angular/router";
import {IUserInfo} from "../../shared/model/userInfo.model";


@Injectable({
    providedIn: 'root'
})
export class UserService {
    constructor(private store: Store,
                private authService: AuthService,
                private supervisorService: SupervisorService,
                private router: Router) { }

    public impersonate(email: string, destination?: string): void {
      this.authService.isImpersonating().pipe(take(1)).subscribe(isImpersonating => {
        if (isImpersonating) {
          /**
           * If switching users, the user will be routed to a temporary loading route to prevent
           * unnecessary api calls that could be made during the transition phase of impersonation.
           */
          this.router.navigate(['/','impersonate-loading']).then(() => {
            this.dispatchImpersonate(email.trim(), destination, isImpersonating);
          });
        } else {
          // Impersonation for non supervisor parts of the application.
          this.dispatchImpersonate(email.trim(), destination, isImpersonating);
        }
      })
    }

    public impersonateSupervisor(supervisorId: string): void {
      this.supervisorService.getSupervisor(supervisorId).subscribe(sup => {
        this.impersonate(sup.email);
      })
    }

    public stopImpersonating(): void {
        this.authService.isImpersonating().pipe(take(1)).subscribe(isImpersonating => {
          if (isImpersonating) {
            // Move off supervisor routes before the session switches back to the impersonator to prevent stale API calls.
            this.router.navigate(['/','impersonate-loading']).then(() => {
              this.store.dispatch(endImpersonateUserAction());
            });
          }
        });
    }

    public signOut(): void {
      this.authService.isImpersonating().subscribe(isImpersonating => {
        if(isImpersonating) {
          this.store.dispatch(logoutEndImpersonateUserAction());
        } else {
          window.location.replace(`${environment.apiUrl}/logout`);
        }
      })
    }

    public isLoadingUserData() {
        return this.store.pipe(select(isLoadingUserDataSelector));
    }

    public getImpersonationHistory(): Observable<IUserInfo[]> {
      return this.authService.getImpersonationHistory();
    }

    public clearImpersonationHistory(): Observable<void> {
      return this.authService.clearImpersonationHistory();
    }

    private dispatchImpersonate(email: string, destination: string | undefined, isImpersonating: boolean | undefined): void {
        if (isImpersonating) {
            this.store.dispatch(switchUserAction({ email }));
        } else {
            this.store.dispatch(impersonateUserAction({ email, destination }));
        }
    }
}
